import React from "react";
import { useSelector } from "react-redux";
import {
	reduxForm,
	Field,
	SubmissionError
} from "redux-form";
import {
	Icon,
	Button,
	ReduxControls,
	ErrorBanner
} from "rhombus-react";

import { createPartnerVastCreative } from "reducers/creatives/VAST";
import { PARTNER_VAST_FORM } from "utils/forms";
import {
	creativeNameAllowedChars,
	creativeNameMaxLength,
	partnerVastURL,
	partnerVastURLMax
} from "widgets/forms/validators/Creatives";
import { requiredNotNull } from "widgets/forms/validators/validators";
import ProgressContainer from "widgets/ProgressContainer";

import "./PartnerVASTForm.css";

const MAX_TAGS = 100;


function NewVASTRow(props){
	const {
			fields,
		} = props
		, canAddInput = fields.length < MAX_TAGS
		;

	function addItem(){
		if(!canAddInput){ return; }
		fields.push({ adType:"vast_tag" });
	}

	function removeItem(name, index) {
		fields.remove(index);
	}

	return (
		<article className="new-vast-row">
			{fields.map((name, index, fields2) => {
				let remove = null;

				if(fields.length > 1){
					remove = <Icon name="removeCircle" className="remove-item" onClick={() => removeItem(name, index)} />;
				}

				/*eslint-disable react/no-array-index-key*/
				return (
					<section className="partner-row" key={index}>
						<Field
							component={ReduxControls.Input}
							className="creative-name"
							name={`${name}name`}
							label="Creative Name"
							required
							validate={[requiredNotNull, creativeNameAllowedChars, creativeNameMaxLength]}
							placeholder="Enter Creative Name..."
						/>
						<Field
							component={ReduxControls.Input}
							className="vast-tag"
							name={`${name}vastTag`}
							label="Creative VAST Tag"
							required
							validate={[requiredNotNull, partnerVastURL, partnerVastURLMax]}
							placeholder="Enter VAST Tag URL..."
						/>
						{remove}
					</section>
				);
				/*eslint-enable react/no-array-index-key*/
			})}
			<Button
				className="add-new-row"
				onClick={addItem}
				style="link"
				disabled={!canAddInput}
			>+ Add another creative tag</Button>
		</article>
	);
}

function PartnerVASTForm(props){
	let { handleSubmit, error } = props
		, isSaving = useSelector(state => state.creatives.isSavingPartnerVast ?? false)
		, errorList = null
		;

	if(error?.length){
		errorList = (
			<ErrorBanner
				type="partneVastError"
				title="Sorry, please fix the errors below and try again."
				messages={error?.map(v => v.message)}
			/>
		);
	}

	return (
		<ProgressContainer isLoading={isSaving}>
			<div className="partner-vast-holder">
				<form
					id={PARTNER_VAST_FORM}
					className="redux-form-container partner-vast-form"
					onSubmit={handleSubmit}
				>
					<header className="header-bar">Enter creative tag(s)</header>
					{errorList}
					<ReduxControls.RowController
						name="creatives"
						component={NewVASTRow}
					/>
				</form>
			</div>
		</ProgressContainer>
	);
}

PartnerVASTForm.displayName = "PartnerVASTForm";
PartnerVASTForm.defaultProps = {
	libraryId:-1,
};

function onSubmit(values, dispatch, formProps){
	return dispatch(createPartnerVastCreative(formProps.libraryId, values))
		.then((resp) => {
			if(resp.success){
				formProps.onClose();
				return resp;
			}

			throw new SubmissionError({
				_error:resp.payload.errorObj.data,
			});
		});
}


export default reduxForm({
	form: PARTNER_VAST_FORM,
	pure: false,
	initialValues:{
		creatives:[{ adType:"vast_tag" }],
	},
	enableReinitialize:true,
	touchOnBlur:false,
	touchOnChange:true,
	onSubmit,
})(PartnerVASTForm);
